module.exports = __webpack_public_path__ + "img/profile_teo0.b4fb41b5.jpg";